import React, { useEffect, useState } from "react"
import { navigate } from "gatsby"
import { useSelector, useDispatch } from "react-redux"
//import uuid from "uuid/v4"
import MenuProduct from "../components/menuProduct"
import Products from "../components/product"
import SEO from "../components/seo"
import { setZone, setPickupPoint/*, addProduct, updateProduct*/ } from "../actions/panier"
import { updateInfosLivraisons } from "../actions/auth"
import Layout from "../components/layout"

const replaceAccent = str => {
  var map = {
    'oe': 'Œ|œ',
    'a': 'á|à|ã|â|À|Á|Ã|Â',
    'e': 'é|è|ê|É|È|Ê',
    'i': 'í|ì|î|Í|Ì|Î',
    'o': 'ó|ò|ô|õ|Ó|Ò|Ô|Õ',
    'u': 'ú|ù|û|ü|Ú|Ù|Û|Ü',
    'c': 'ç|Ç',
    'n': 'ñ|Ñ'
  }
  for (var pattern in map) {
    str = str.replace(new RegExp(map[pattern], 'g'), pattern);
  }
  return str
}

export const LivraisonPage = props => {
  const dispatch = useDispatch()
  const panier = useSelector(state => state.panierR)
  const identifiants = useSelector(s => s.identifiants)
  const loading = useSelector(state => state.loadingR)
  const [search, setSearch] = useState("")

  const allProducts = loading && loading.produits && loading.produits.length ? loading.produits : props.pageContext.produits
  const allCategories = (loading && loading.categories && loading.categories.length > 0 ? loading.categories : props.pageContext.categories)
    .sort((a, b) => parseInt(a.cat_order) > parseInt(b.cat_order))
  const currentCateg = parseInt(props.pageContext.cat || allCategories[0]?.cat_id)
  const isSearchMode = search && search.length > 1
  const filteredProducts = isSearchMode ? allProducts.filter(p => replaceAccent(p.product_name).toLowerCase().search(replaceAccent(search).toLowerCase()) >= 0) : allProducts
  const filteredCategories = isSearchMode ? [...new Set((filteredProducts).map(data => parseInt(data.product_cat)))] : [currentCateg]
  const currentLivraisons = loading.livraisons || [props.pageContext.livraison]
  const currentPointDepot = panier.pickupPoint !== null ? panier.pickupPoint : (identifiants.identifiants !== null ? identifiants.identifiants.customer_group : null)
  const isBrowser = typeof window !== "undefined"
  const isDataOutdated = loading.dateMaj < new Date() - 1000 * 60 * 30

  if (isBrowser && (!props.pageContext || props.pageContext.slug === undefined || props.pageContext.slug === null)) {
    navigate(`/`)
  }

  useEffect(() => {
    if (isBrowser && panier.pickupPoint === null && identifiants.identifiants !== null) {
      dispatch(setPickupPoint(currentPointDepot))
      dispatch(setZone(props.pageContext.slug))
    }
  }, [panier.pickupPoint, identifiants.identifiants, isBrowser, dispatch, currentPointDepot, props.pageContext.slug])

  useEffect(() => {
    if (isBrowser && ((isDataOutdated || loading.dateMaj === null) || loading.thisZone !== props.pageContext.slug)) {
      dispatch(updateInfosLivraisons(props.pageContext.zone_id, 0, identifiants.identifiants !== null ? identifiants.identifiants.customer_id : null))
    }
  }, [props.pageContext, loading.dateMaj, isDataOutdated, loading.thisZone, isBrowser, dispatch, identifiants.identifiants])

  return (
    <Layout>
      <SEO title="Livraison" />
      <div className="columns is-mobile pattern-cross-dots family-parent" style={{marginLeft: 0, marginRight: 0}}>
        <MenuProduct
          zone_id={props.pageContext.zone_id}
          zone_info={props.pageContext.zone_info}
          allCategories={allCategories}
          currentCateg={currentCateg}
          currentLivraisons={currentLivraisons}
          currentPointDepot={currentPointDepot}
          search={search}
          setSearch={setSearch}
        />
        <Products
          zone_id={props.pageContext.zone_id}
          zone_info={props.pageContext.zone_info}
          allCategories={allCategories}
          filteredCategories={filteredCategories}
          currentCateg={currentCateg}
          currentLivraisons={currentLivraisons}
          produits={filteredProducts}
          displaySearch={isSearchMode}
        />
      </div>
    </Layout>
  )
}

export default LivraisonPage
